// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"wS-z","categoryName":"xS-z","categoryNameSearchHeader":"yS-z","categoryContent":"zS-z","bottomAligned":"AS-z","image":"BS-z","imageNoBackground":"CS-z"};